import jsonSchemas from './jsonSchemas';

function getPathFromId(id) {
  return id
    .split('_')
    .slice(1)
    .join('.');
}

function getSchemaPathForPath(path, formSchema) {
  const arraySchemas = jsonSchemas
    .collectSchemaChainFor(path, {
      type: 'object',
      properties: formSchema,
    })
    .map(sc => sc.type === 'array');

  return path
    .split('.')
    .map((p, pidx) => (arraySchemas[pidx] ? 'items' : `${pidx ? 'properties.' : ''}${p}`))
    .join('.');
}

function makeFieldId(field) {
  return `root_${field.replace(/^\./, '').replaceAll('.', '_')}`;
}

export { getSchemaPathForPath, makeFieldId };
export default getPathFromId;
